import React, { Component, getGlobal } from "reactn";
import { MenuItem, Select, Link } from "@material-ui/core";

import {
    flattenPermissions,
    InviteInputWithGContacts
} from "js/react/components/EmailInput/InviteInput";
import PermissionsList from "./PermissionsList";
import TeamFoldersList from "js/react/views/PresentationSettings/panes/TeamFoldersList";
import permissionsDS from "js/react/views/PresentationSettings/dataservices/PermissionsDataService";
import { incUserProps } from "js/analytics";
import { app } from "js/namespaces";
import { trackActivity } from "js/core/utilities/utilities";
import log from "js/core/logger";
import {
    Section,
    UIPane,
    UIPaneContents,
    UIPaneHeader,
    BlueButton
} from "js/react/components/UiComponents";
import { BlueSwitch } from "js/react/components/Switch";
import { getPricingPageUrl } from "js/core/utilities/pricing";
import { FeatureType } from "common/features";
import { Gap10, Gap30 } from "../../../components/Gap";
import { _ } from "../../../../vendor";
import { ShowErrorDialog } from "../../../components/Dialogs/BaseDialog";
import TextArea from "js/react/components/TextArea";

export default class CollaboratePane extends Component {
    state = {
        emails: [],
        customMessage: "",
        permission: "write",
        isInviteDisabled: true,
        isNotificationsSettingsFetching: true,
        notificationsSettings: {
            notifyOnEdit: true,
            notifyOnComment: false,
            notifyOnCommentMentioningMe: true,
            notifyOnCommentOnAssignedSlide: false
        },
    };

    componentDidMount() {
        const presentation = this.global.presentation;
        const presentationNotificationsSettings = app.user.get("presentationNotificationsSettings");

        let notificationsSettings = {
            notifyOnEdit: !!presentation.permissions.owner,
            notifyOnComment: false,
            notifyOnCommentMentioningMe: true,
            notifyOnCommentOnAssignedSlide: true
        };

        if (presentationNotificationsSettings && presentationNotificationsSettings[presentation.id]) {
            notificationsSettings = { ...notificationsSettings, ...presentationNotificationsSettings[presentation.id] };
        }

        this.setState({
            notificationsSettings,
            isNotificationsSettingsFetching: false
        });
    }
    async handleNotificationsSettingsChange(changedKey, changedValue) {
        const { notificationsSettings } = this.state;

        const presentation = this.global.presentation;
        const presentationId = this.global.presentationId;
        const oldNotificationsSettings = notificationsSettings;

        const updatedNotificationsSettings = { ...notificationsSettings, [changedKey]: changedValue };

        // notifyOnComment means "notify on all comments", so we want to disable it if any other setting was enabled
        // and vice versa
        if (changedKey === "notifyOnComment" && changedValue) {
            updatedNotificationsSettings.notifyOnCommentMentioningMe = false;
            updatedNotificationsSettings.notifyOnCommentOnAssignedSlide = false;
        } else if (["notifyOnCommentMentioningMe", "notifyOnCommentOnAssignedSlide"].includes(changedKey) && changedValue) {
            updatedNotificationsSettings.notifyOnComment = false;
        }

        try {
            app.user.update({ presentationNotificationsSettings: { [presentationId]: updatedNotificationsSettings } });
            await app.user.updatePromise;
            this.setState({ notificationsSettings: updatedNotificationsSettings });
            const props = {
                current_slide_count: presentation.getWorkspaceSlideCount(),
                setting_changed: changedKey,
                old_value: oldNotificationsSettings[changedKey],
                new_value: changedValue,
                scope: "presentation",
                presentation_id: presentationId,
                workspace_id: presentation.getWorkspaceId()
            };
            trackActivity("Notification", "SettingChanged", null, null, props, { audit: true });
        } catch (err) {
            console.error(err);
            this.setState({ notificationsSettings: oldNotificationsSettings });
        }
    }

    handleDuplicatedEmails = (flattenedEmailsObj, duplicatedEmails) => {
        const { emails } = this.state;
        this.setState({
            emails: emails.filter(tag => (tag.email ? !flattenedEmailsObj[tag.email] : !flattenedEmailsObj[tag])),
        });

        const errorMessage = "The following users already have access to this presentation: ";
        ShowErrorDialog({
            error: "Oops!",
            message: errorMessage.concat(duplicatedEmails.join(", "))
        });
    };

    handleAccept = () => {
        const { emails, permission, customMessage } = this.state;

        const presentationPermissions = this.global.presentationPermissions;
        const permissions = _.filter(
            presentationPermissions.permissions,
            perm => perm.invite == false || perm.invite == undefined
        );
        const flattenedEmailsObj = flattenPermissions(permissions);
        const duplicatedEmails = emails.filter(email => flattenedEmailsObj[email]);
        if (duplicatedEmails.length) {
            this.handleDuplicatedEmails(flattenedEmailsObj, duplicatedEmails);
            return;
        }

        const payload = { emails, permission, customMessage };

        this.setState({ emails: [], permission: "write", customMessage: "" });

        permissionsDS
            .createPermission(payload, getGlobal().presentation.id, true)
            .then(() => {
                let presentationId = getGlobal().presentation.id;
                incUserProps({
                    invites: payload.emails.length
                });
                const props = {
                    old_value: null,
                    new_value: payload.permission,
                    recipient_emails: payload.emails,
                    sender_email: app.user.getEmail(),
                    location: "settings"
                };
                trackActivity("Collab", "Invite", null, null, props, { audit: true });

                let message = payload.emails[0];
                if (payload.emails.length > 1) {
                    message += ` and ${payload.emails.length - 1} other${payload.emails.length > 2 ? "s" : ""}`;
                }
                this.setGlobal({ alertMessage: `Email sent to ${message}` });
            })
            .catch(err => {
                if (err) {
                    log.error(err);
                    ShowErrorDialog({
                        error: "Oops!",
                        message: err.message
                    });
                }
            });
    }

    handleInputChange = (emails, isInviteDisabled) => {
        this.setState({ emails, isInviteDisabled });
    }

    handleChangeCustomMessage = customMessage => {
        this.setState({
            customMessage
        });
    }

    handleDropdownChange = value => {
        this.setState({ permission: value });
    }

    handleSalesCalendar = () => {
        window.open("https://calendly.com/beautifulteam/demo-call-with-beautiful-ai-upgrade-to-team", "_blank");
    }

    handlePricingPage = () => {
        const { presentation } = this.global;
        const workspaceId = presentation.getWorkspaceId();
        const userIsBasicInWorkspace = app.user.features.isFeatureEnabled(FeatureType.UPGRADE, workspaceId);
        const currentPlan = userIsBasicInWorkspace ? "basic" : app.user.analyticsPersonalPlan;
        window.open(getPricingPageUrl(app && app.user.hasTakenTrial, app && app.user.has("hasTakenTeamTrial"), currentPlan), "_blank");
    };

    render() {
        const { isNotificationsSettingsFetching, notificationsSettings: { notifyOnEdit, notifyOnComment, notifyOnCommentMentioningMe, notifyOnCommentOnAssignedSlide }, emails, customMessage, isInviteDisabled, permission } = this.state;
        const { presentation } = this.global;
        const isOrgWorkspace = presentation.getWorkspaceId() !== "personal";
        return (
            <UIPane className="collaborate-pane">
                <UIPaneHeader>Collaborate{isOrgWorkspace ? " with your team" : ""}</UIPaneHeader>
                <UIPaneContents>
                    <Section title="Invite other users to collaborate on this presentation">
                        <div style={{ display: "flex", width: "100%" }}>
                            <InviteInputWithGContacts
                                onInputChange={this.handleInputChange}
                                tags={emails}
                                showGoogleContacts={false}
                            />
                            <Gap10 />
                            <Select
                                variant="outlined"
                                value={permission}
                                onChange={event => this.handleDropdownChange(event.target.value)}
                            >
                                <MenuItem value="write">Can Edit</MenuItem>
                                <MenuItem value="read">Can View</MenuItem>
                            </Select>
                        </div>

                        <Gap10 />
                        <TextArea
                            isVisible
                            text={customMessage}
                            onChange={customMessage => this.handleChangeCustomMessage(customMessage)}
                            placeholder="Add a note..."
                        />

                        <Gap10 />
                        <div style={{ textAlign: "right" }}>
                            {emails.length > 0 && (
                                <BlueButton disabled={isInviteDisabled} onClick={this.handleAccept}>
                                    Send Invite
                                </BlueButton>
                            )}
                        </div>
                    </Section>

                    <Section title="Add to a Team Shared Folder">
                        {isOrgWorkspace && <TeamFoldersList organizationId={presentation.get("orgId")} />}
                        {!isOrgWorkspace && <div>
                            <p>Upgrade to the Team plan and share presentations in a click. </p>
                            <Link underline="hover" onClick={this.handlePricingPage}>See our Plans</Link>
                            <Gap30/>
                            <BlueButton onClick={this.handleSalesCalendar}>Talk To An Expert</BlueButton>
                        </div>}
                    </Section>

                    <Section title="Who has access">
                        <PermissionsList orgId={presentation.get("orgId")} />
                    </Section>

                    <Section title="Notifications settings">
                        <BlueSwitch
                            checked={notifyOnEdit}
                            onChange={() => this.handleNotificationsSettingsChange("notifyOnEdit", !notifyOnEdit)}
                            disabled={isNotificationsSettingsFetching}
                            label="Notify me when presentation is changed"
                        />
                        <BlueSwitch
                            checked={notifyOnComment}
                            onChange={() => this.handleNotificationsSettingsChange("notifyOnComment", !notifyOnComment)}
                            disabled={isNotificationsSettingsFetching}
                            label="Notify me on all comments"
                        />
                        <BlueSwitch
                            checked={notifyOnCommentMentioningMe}
                            onChange={() => this.handleNotificationsSettingsChange("notifyOnCommentMentioningMe", !notifyOnCommentMentioningMe)}
                            disabled={isNotificationsSettingsFetching}
                            label="Notify me on comments that mention me"
                        />
                        <BlueSwitch
                            checked={notifyOnCommentOnAssignedSlide}
                            onChange={() => this.handleNotificationsSettingsChange("notifyOnCommentOnAssignedSlide", !notifyOnCommentOnAssignedSlide)}
                            disabled={isNotificationsSettingsFetching}
                            label="Notify me on comments on slides assigned to me"
                        />
                    </Section>
                </UIPaneContents>
            </UIPane>
        );
    }
}
